import styled from 'styled-components';

const VehicleDetailsWrapper = styled.div`
  align-content: center;
  border-radius: ${(props) => props.theme.border.radius};
  background-color: ${(props) => props.theme.color.neutral.v100};
  display: flex;
  justify-content: left;
  flex-direction: column;
  padding-bottom: 24px;

  @media (min-width: ${(props) =>
      props.theme.breakpoint.sm}px) and (max-width: 680px) {
    flex-direction: column;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    flex-direction: row;
    // padding: 0 0 25px 0;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.lg}px) {
    flex-direction: row;
    // padding: 0 0 32px 0;
  }
`;

const Image = styled.img`
  width: 100%;
  border-radius: 4px;
  @media (min-width: ${(props) => props.theme.breakpoint.sm}px) {
    min-width: 280px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    max-width: 285px;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.xxl}px) {
    margin: 0;
  }
`;

const CarInfo = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${(props) => props.theme.breakpoint.sm}px) {
    padding: 15px 0 0;
  }

  // TODO - is this needed here?
  @media (min-width: ${(props) =>
      props.theme.breakpoint.sm}px) and (max-width: ${(props) =>
      props.theme.breakpoint.md}px) {
    padding: 15px 0 0;
  }

  @media (min-width: ${(props) => props.theme.breakpoint.md}px) {
    padding: 0 0 0 40px;
  }
`;

const Status = styled.span`
  background-color: ${(props) => props.theme.color.primary.v400};
  border-radius: 20px;
  color: ${(props) => props.theme.color.neutral.v100};
  display: inline-block;
  ${(props) => props.theme.font.label.v200};
  font-weight: ${(props) => props.theme.font.weight.v300};
  height: 30px;
  min-width: 90px;
  line-height: 30px;
  text-align: center;
  text-transform: uppercase;
  align-self: flex-start;
  padding: 0 20px;
`;

const Make = styled.h4<{ isOverviewCard: boolean }>`
  color: ${(props) => props.theme.color.primary.v600};
  ${(props) => props.theme.font.heading.v100};
  font-weight: ${(props) => props.theme.font.weight.v300};
  margin: 0;
  text-transform: uppercase;
`;

const Model = styled.h5`
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: ${(props) => props.theme.font.weight.v200};
  ${(props) => props.theme.font.subhead.v500};
  margin: 12px 0 0;
`;

const PurchaseInfo = styled.p<{ isOverviewCard: boolean }>`
  color: ${(props) => props.theme.color.neutral.v500};
  font-weight: ${(props) => props.theme.font.weight.v200};
  ${(props) => props.theme.font.body.v300};
  margin: 5px 0 0;
`;

const Date = styled.span`
  font-weight: ${(props) => props.theme.font.weight.v300};
`;

const OverviewHeading = styled.h3`
  margin-bottom: 16px;
  color: #00619e;
  font-size: 14px;
  text-transform: uppercase;
`;

const OverviewVinNumber = styled.span`
  margin-top: 10px;
  color: #6d7184;
  font-size: 18px;
`;

export {
  VehicleDetailsWrapper,
  Image,
  CarInfo,
  Status,
  Make,
  Model,
  PurchaseInfo,
  Date,
  OverviewHeading,
  OverviewVinNumber,
};
